<template>
  <div>
    <SaleHeader :img_header="header_image" header="ตั้งค่าข้อมูลการขาย" link_back="managewebsite"/>
    <MenuSale/>
    <Transfer_setting/>
  </div>
</template>

<script>
import SaleHeader from "@/components/admin/manage_website/sale_setting/menu_sale/SaleHeader";
import HeaderImage from "@/assets/motivation.png";
import MenuSale from "@/components/admin/manage_website/sale_setting/menu_sale/MenuSale";
import Transfer_setting from "@/components/admin/manage_website/sale_setting/Transfer_setting";
export default {
  name: "TransferSetting",
  components: {
    Transfer_setting,
    MenuSale,
    SaleHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
